import { Logo } from './Logo';
import { MarketplaceSelector } from './MarketplaceSelector';
import { UserInfo } from './UserInfo';
import HelpMenu from '../../../general/HelpMenu'; // Added HelpMenu for user support
import { DeviceFamilySelector } from '../select/DeviceFamilySelector';
import { useContext } from 'react';
import { SmartUploadContext } from 'src/contexts/SmartUploadContext';
import styles from './Header.module.css';

const Header = () => {
  const ctx = useContext(SmartUploadContext);
  const isStandard = !ctx || ctx.mode !== 'smart';

  return (
    <header className={styles.header}>
      <div className={styles.headerContent}>
        <div className={styles.logoSection}>
          <Logo />
        </div>
        <div className={styles.rightSection}>
          {isStandard && <DeviceFamilySelector />}
          {isStandard && <MarketplaceSelector />}
          <HelpMenu /> {/* Help menu with demo and support options */}
          <UserInfo />
        </div>
      </div>
    </header>
  );
};

export { Header };
